export enum Severity {
  error = 'error',
  warning = 'warning',
  info = 'info',
  success = 'success',
}
